import React, { useEffect, useMemo, useState } from "react";
import { RowFlex, Add } from "./style";
import Button from "../../../components/FormElement/Button";
import StatCard from "../../../components/Cards/StatCard";
import Spinner from "../../../components/Spinner/FullScreen";
import { PlusOutlined } from "@ant-design/icons";
import { useHideModal, useShowModal } from "../../../hooks";
import Pagination from "../../../components/FormElement/Pagination";
import service from "../../../services/statistics";
import Form from "./Form";
import DeleteModal from "../../../components/DeleteModal";
import { useShowAlert } from "../../../hooks/useAlerts";

function Section() {
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}`,
    [pageQuery, limitQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item) => ({
        ...item,
        img: item?.media,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [query]);
  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };
  const handleDelete = (id) => {
    if (id) {
      showBlured({
        title: "",
        maxWidth: "400px",
        maxHeight: "500px",
        withHeader: false,
        body: () => <DeleteModal onClick={() => handleDel(id)} />,
      });
    }
  };
  const handleDel = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEdit = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form fetch={fetchData} edit={data?.id} />,
    });
  };
  const handleNum = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form fetch={fetchData} edit={data} active />,
    });
  };

  const handleShowModal = () => {
    showBlured({
      title: "Bo'lim yarating",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form fetch={fetchData} />,
    });
  };

  if (loading) return <Spinner />;
  return (
    <div>
      <Add>
        <Button
          text="Qo'shish"
          icon={<PlusOutlined />}
          onClick={handleShowModal}
        />
      </Add>
      <RowFlex>
        {data.map((item) => (
          <div className="card" key={item.id}>
            <StatCard
              data={item}
              onDelete={handleDelete}
              onEdit={handleEdit}
              handleNum={handleNum}
            />
          </div>
        ))}
      </RowFlex>
      {total > 10 && (
        <Pagination
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </div>
  );
}

export default Section;
